import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { Article, ArticleCategory } from "models";
import type { PAGE_SIZE } from "utils/common";

export type NewsQueryResponse = {
  nb_pages: number;
  articles: Article[];
  nb_items: number;
};

export type NewsFilters = {
  category_ids: number[] | null;
  dealer_ids: number[] | null;
  page: number;
  page_size: PAGE_SIZE;
  published_date: null | string;
  search_term: string | null;
  language_code: string;
};

const component = "NewsDashboard";

export const NewsQueryKeys = {
  newsFilters: localQueryKey<NewsFilters>({ component, data: "newsFilters" }),
  articles: backendQueryKey<NewsQueryResponse>({ baseUrl: ENV.dealerBaseURL, endpoint: "/articles/list", component }),
  unreadArticles: backendQueryKey<Article[]>({ baseUrl: ENV.dealerBaseURL, endpoint: "/articles/unread/list", component }),
  categoryList: backendQueryKey<ArticleCategory[]>({ baseUrl: ENV.dealerBaseURL, endpoint: "/articles/categories/list", component })
};
